// extracted by mini-css-extract-plugin
export default {"tab":"CaseTab_tab__kGWQ2","title":"CaseTab_title__TEguR"};